export enum TotWaiver {
  TOT_10_YEARS = 'U',
  TOT_CHAIRMAN = 'Y',
}
